import react from "react";
import { createComponent } from "@lit/react";
import { MdFilterChip } from "@material/web/chips/filter-chip";
import { MdInputChip } from "@material/web/chips/input-chip";
import { MdChipSet } from "@material/web/chips/chip-set";

export const LitFilterChip = createComponent({
  tagName: "md-filter-chip",
  elementClass: MdFilterChip,
  react,
  events: { onRemove: "remove" }
});

export const LitInputChip = createComponent({
  tagName: "md-input-chip",
  elementClass: MdInputChip,
  react,
  events: { onRemove: "remove" }
});

export const LitChipSet = createComponent({
  tagName: "md-chip-set",
  elementClass: MdChipSet,
  react
});
